// File: src/components/AppProviders.js
// The context stack every view needs.
//
// This was duplicated in each of App's return branches; a single wrapper keeps
// the nesting order in one place.

import React from 'react';
import { ThemeProvider } from '../contexts/ThemeContext';
import { CountryProvider } from '../contexts/CountryContext';
import { LanguageProvider } from '../contexts/LanguageContext';

function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <CountryProvider>
        <LanguageProvider>
          {children}
        </LanguageProvider>
      </CountryProvider>
    </ThemeProvider>
  );
}

export default AppProviders;
